import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Logo } from "@/components/Logo";
import { api, formatApiError } from "@/lib/api";

export default function ResetPassword() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const nav = useNavigate();
    const [pw, setPw] = useState("");
    const [confirm, setConfirm] = useState("");
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState("");

    async function onSubmit(e) {
        e.preventDefault();
        setErr("");
        if (pw !== confirm) { setErr("Passwords do not match"); return; }
        setBusy(true);
        try {
            await api.post("/auth/reset-password", { token, new_password: pw });
            toast.success("Password updated. Please sign in.");
            nav("/admin/login", { replace: true });
        } catch (e) { setErr(formatApiError(e)); }
        finally { setBusy(false); }
    }

    return (
        <div className="min-h-screen bg-[color:var(--gsf-green-900)] text-white flex items-center justify-center px-4" data-testid="reset-password">
            <div className="w-full max-w-md">
                <div className="flex justify-center mb-8"><Logo variant="full" size={110} className="rounded-xl bg-white p-2" /></div>
                <div className="bg-white text-[color:var(--gsf-charcoal)] rounded-2xl p-8 shadow-2xl">
                    <div className="gsf-eyebrow">Set new password</div>
                    <h1 className="mt-2 font-serif text-2xl text-[color:var(--gsf-green-700)] font-bold">Reset your password</h1>
                    {!token ? (
                        <p className="mt-4 text-sm text-red-600" data-testid="reset-no-token">Missing or invalid reset token.</p>
                    ) : (
                        <form onSubmit={onSubmit} className="mt-6 space-y-4">
                            <div>
                                <label className="text-sm font-medium">New password</label>
                                <input required type="password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-new"
                                    className="mt-1 w-full rounded-lg border border-gray-200 px-4 py-3 focus:outline-none focus:border-[color:var(--gsf-green-700)]" />
                                <p className="mt-1 text-xs text-gray-500">Min 12 chars, mix upper/lower/digit/symbol</p>
                            </div>
                            <div>
                                <label className="text-sm font-medium">Confirm new password</label>
                                <input required type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="reset-confirm"
                                    className="mt-1 w-full rounded-lg border border-gray-200 px-4 py-3 focus:outline-none focus:border-[color:var(--gsf-green-700)]" />
                            </div>
                            {err && <p className="text-sm text-red-600" data-testid="reset-error">{err}</p>}
                            <button type="submit" disabled={busy} className="gsf-btn-primary w-full justify-center disabled:opacity-60" data-testid="reset-submit">
                                {busy ? "Updating…" : "Update password"}
                            </button>
                        </form>
                    )}
                    <div className="mt-4 text-sm">
                        <Link to="/admin/login" className="text-[color:var(--gsf-green-700)] hover:underline">Back to sign in</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
